import React, { useState } from 'react';
import { ConfigurationSection, SpaceBetweenRow } from "@features/settings/pages/StyleComponents";
import { BodyLarge, BodyRegular } from "../../atoms/fonts/Body";
import Colours from "../../atoms/Colours";
import { Switch } from "../../atoms/Switch";
import { updateCompanySetting } from '@features/settings/services/CompanyService';
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUser, updateCurrentUser } from '@shared/store/auth.duck';
import { failureNotification } from '@shared/store/notification.duck';
import { SimpleSpinner } from "../../atoms/SimpleSpinner";
import { useTranslation } from "react-i18next";

const FIELD = 'CALENDAR_SYNC'

export function CalendarSyncSetting(props: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector(selectCurrentUser);
  const calendarSyncEnabled = user?.companyEntity?.calendarSyncEnabled;
  const {t} = useTranslation();

  const onChange = async (value: boolean) => {
    try {
      setIsLoading(true);
      await updateCompanySetting(FIELD, value);
      dispatch(updateCurrentUser(true));
    } catch (e: any) {
      dispatch(failureNotification('Failed to update setting, please wait a minute.'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ConfigurationSection className={'calendarSync__section'}>
      <SpaceBetweenRow>
        <BodyLarge colour={Colours.blue}>{t('settings.calendar-sync.title')}</BodyLarge>
        {isLoading ? <SimpleSpinner size={32} /> : <Switch value={!!calendarSyncEnabled} label="" onChange={onChange}/>}
      </SpaceBetweenRow>
      <BodyRegular>{t('settings.calendar-sync.subtitle')}</BodyRegular>
    </ConfigurationSection>
  )
}

interface Props {
}
